// @flow
import React from 'react';
import Select from 'components/Select';
import { getter, compose } from 'utils/functional';
import { LISTING_TYPE_HUMAN_NAME_MAP_SEARCH } from 'utils/constants';

type DisplayedType = ListingType | StaffTypeFilter;

const ListingTypeSelect = ({
  value,
  onChange,
  listingTypes,
  ...props
}: {
  value: string,
  onChange: ListingType => void,
  listingTypes: Array<DisplayedType>
}) => {
  const options = listingTypes.map(type => ({
    value: type,
    label: LISTING_TYPE_HUMAN_NAME_MAP_SEARCH[type]
  }));

  const selectValue = options.map(({ value: v }) => v).find(v => v === value);

  return (
    <Select
      data-qa-id="listing-type-select"
      aria-label={getText('Select listing type')}
      name="listing-types"
      options={options}
      value={selectValue}
      onChange={compose(
        onChange,
        getter('value')
      )}
      isSearchable={false}
      isClearable={false}
      isDisabled={listingTypes.length === 1}
      {...props}
    />
  );
};

export default ListingTypeSelect;
